// Define fetchConfig if it doesn't exist yet
if (typeof fetchConfig === 'undefined') {
  function fetchConfig(type = 'json') {
    return {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
    };
  }
}

if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        // Check if routes object exists
        if (typeof window.routes === 'undefined' || !window.routes.cart_add_url) {
          console.error('Cart routes not defined. Ensure window.routes is properly initialized.');
          this.handleErrorMessage('An error occurred. Please refresh the page and try again.');
          this.submitButton.classList.remove('loading');
          this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading__spinner').classList.add('hidden');
          return;
        }

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  }, 100);
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              try {
                // Ensure the cart drawer is properly initialized
                if (this.cart && typeof this.cart.renderContents === 'function') {
                  // First make sure the cart drawer is active
                  if (this.cart.tagName.toLowerCase() === 'cart-drawer' && typeof this.cart.open === 'function') {
                    // Save a reference to the response for use in the timeout
                    const responseData = { ...response };
                    
                    // Open the drawer first
                    this.cart.open();
                    
                    // Increase delay to ensure the drawer is fully opened before rendering content
                    setTimeout(() => {
                      // Check if drawer is still active before trying to render
                      if (this.cart.classList.contains('active')) {
                        // Set a flag on the cart drawer to prevent premature closing
                        if (typeof this.cart.isRenderingContent !== 'undefined') {
                          this.cart.isRenderingContent = true;
                        }
                        this.cart.renderContents(responseData);
                        
                        // Add a small delay to ensure animation completes properly
                        setTimeout(() => {
                          // Reset the flag if it exists
                          if (typeof this.cart.isRenderingContent !== 'undefined') {
                            this.cart.isRenderingContent = false;
                          }
                        }, 800);
                      } else {
                        console.warn('Cart drawer not active when attempting to render contents');
                        this.cart.open();
                        // Try again after a longer delay
                        setTimeout(() => {
                          this.cart.renderContents(responseData);
                        }, 500);
                      }
                    }, 400);
                  } else {
                    this.cart.renderContents(response);
                  }
                } else {
                  console.error('Cart drawer not found or renderContents not available');
                }
              } catch (error) {
                console.error('Error opening cart drawer:', error);
              }
            }
          })
          .catch((e) => {
            console.error(e);
            this.handleErrorMessage('An error occurred. Please try again later.');
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
